/*eslint-disable*/
import React from "react";

// reactstrap components
import { Row, Container } from "reactstrap";

function Footer() {
  return (
    <footer className="footer footer-black footer-white">
      <Container>
        <Row>
          <nav className="footer-nav">
            <ul>
              <li>
                <a href="https://www.facebook.com/CashOnemn" target="_blank">
                  <i className="fa fa-facebook-f" />
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  <i className="fa fa-twitter" />
                </a>
              </li>
              <li>
                <a href="#" target="_blank">
                  <i className="fa fa-linkedin" />
                </a>
              </li>
            </ul>
          </nav>
          <div className="credits ml-auto">
            <span className="copyright">
              © 2021 Cashone. All rights reserved
            </span>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
